const defaultAPRs = {
  "5": 0.0527,
  "10": 0.0488,
  "20": 0.0488,
  "30": 0.0488,
}

export default defaultAPRs